import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../../../../../AriaPopover/index.js';
import { useSelectPopover } from './hooks/useSelectPopover.js';
import { AriaPopover } from '../../../../../AriaPopover/AriaPopover.js';

var SelectPopover = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children;
  var result = useSelectPopover(props);
  return result !== null && result !== void 0 && result.popoverProps ? /*#__PURE__*/React.createElement(AriaPopover, _extends({
    ref: ref
  }, result.popoverProps), children) : null;
}));

export { SelectPopover };
//# sourceMappingURL=SelectPopover.js.map
